module.exports = __webpack_public_path__ + "static/media/pass_success.1c09231d.svg";